module.exports = __webpack_public_path__ + "img/cases-brand-vive-lazyload-71.f5d76dfc.jpg";